import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseUrlStorage = process.env.REACT_APP_STORAGE_SERVICE;

export const getProfileImage = createAsyncThunk('getProfileImage', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlStorage}/document`, { params: queryParams, responseType: 'blob' });
        const blob = new Blob([response.data], {
            type: 'application/octet-stream',
        });
        const imageURL = URL.createObjectURL(blob);
        return imageURL;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const uplaodDocument = createAsyncThunk('uplaodDocument', async (data, thunkAPI) => {
    try {
        const response = await axios.put(`${baseUrlStorage}/document`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const payload = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
